import { createFileRoute, redirect } from '@tanstack/react-router';
import { useGame } from '@/store/game';
import { GameScreen } from '@/components/game/GameScreen';
import { readRejoinMemo } from '@/components/lobby/RejoinCard';

export const Route = createFileRoute('/play')({
  beforeLoad: () => {
    if (useGame.getState().game) return;
    // A guest whose page reloaded has no game yet; send them back to their
    // room so the host can re-send it.
    const memo = readRejoinMemo();
    if (memo)
      throw redirect({ to: '/join/$code', params: { code: memo.code } });
    throw redirect({ to: '/' });
  },
  component: PlayPage,
});

function PlayPage() {
  const game = useGame(s => s.game);
  if (!game) return null;
  return <GameScreen game={game} />;
}
